import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

// Importaciones de entornos.
import { environment } from '../../environments/environment';

// Importaciones de servicios.
import { AuthService } from '../services/auth.service';

/**
 * Interceptor de autenticación que añade el token de autenticación a las cabeceras de las peticiones HTTP.
 * Este interceptor verifica si la petición no está dirigida a la ruta '/auth' y, en ese caso,
 * agrega el token de autenticación al encabezado 'Authorization' para asegurar que
 * solo las solicitudes autenticadas accedan a las rutas protegidas.
 *
 * @param req - La solicitud HTTP original.
 * @param handler - El siguiente manejador de la solicitud en la cadena de interceptores.
 *
 * @returns Observable de la respuesta HTTP, con el token añadido en las cabeceras si corresponde.
 */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  handler: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const url = new URL(req.url);

  if (url.origin !== environment.apiUrl || url.pathname === '/auth/login') {
    return handler(req);
  }

  const authService = inject(AuthService);
  const token = authService.getToken();

  // Si no está logueado, redirigimos a la página de login.
  if (!authService.isValidToken(token)) {
    const router = inject(Router);

    authService.removeToken();
    router.navigateByUrl('/login');

    return handler(req);
  }

  // Si está logueado añadimos el token a la petición.
  return handler(req.clone({ setHeaders: { 'x-token': token } }));
};
